<template>
  <v-row>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          label="サイト名"
          :value="terminalView.name"
          hide-details>
      </text-field-like>
      <v-text-field
          v-else
          label="サイト名"
          v-model="terminalView.name"
          :rules="[v => !!v || 'サイト名が必要です']"
          autofocus>
      </v-text-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          label="説明"
          :value="terminalView.description"
          placeholder="未入力"
          multi-line
          hide-details>
      </text-field-like>
      <v-textarea
          v-else
          label="説明"
          messages="複数行入力可"
          v-model="terminalView.description"
          rows="1"
          auto-grow>
      </v-textarea>
    </v-col>
    <v-col cols="12" v-if="terminalView.id">
      <text-field-like
          v-if="readonly"
          label="ポーリング周期 (秒)"
          :value="terminalView.pollingRate"
          hide-details>
      </text-field-like>
      <v-text-field
          v-else
          label="ポーリング周期 (秒)"
          v-model="terminalView.pollingRate"
          :rules="[
            v => !!v || 'ポーリング周期が必要です',
            v => v <= 1000 || 'ポーリング周期は1000以下の値にしてください。',
            v => v >= 10 || 'ポーリング周期は10以上の値にしてください。'
          ]"
          autofocus>
      </v-text-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          :value="terminalView.publishing ? '公開' : '非公開'"
          label="公開状態">
      </text-field-like>
      <v-checkbox
          v-else
          label="公開"
          v-model="terminalView.publishing"
          style="width: fit-content;"
          hide-details>
        <template #append>
          <el-tooltip
              v-if="!readonly"
              placement="right">
            <template #content>
              他の事業者にこのサイトを公開する場合はチェックします。
            </template>
            <template #default>
              <v-icon small color="blue" style="top: 4px;">mdi-help-circle</v-icon>
            </template>
          </el-tooltip>
        </template>
      </v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
export default {
  name: 'TerminalForm',
  components: {TextFieldLike},
  model: {
    prop: 'terminal',
    event: 'change-form'
  },
  props: {
    terminal: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      terminalView: {}
    }
  },
  watch: {
    terminal: {
      immediate: true,
      handler(value) {
        this.terminalView = value
      }
    },
    terminalView: {
      deep: true,
      handler() {
        this.$emit('change-form', this.terminalView)
      }
    }
  }
}
</script>
